
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Box,
  Drawer,
  useMediaQuery,
  IconButton,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { PiMicrosoftTeamsLogoBold, PiUsersThreeFill } from "react-icons/pi";
import { RxExit } from "react-icons/rx";
import logo from "../../Assets/logo.png";
import { MdDashboard } from "react-icons/md";
import { ImStack } from "react-icons/im";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { GoDotFill } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { logout, logoutUser } from "../../ReduxStore/Slices/authSlice";
// import { logout } from '../../ReduxStore/Slices/authSlice';
import { MdOutlineDashboard } from "react-icons/md";
import "./Sidebar.css";
import { FaUserCog } from "react-icons/fa";
import { LuUserRoundCog } from "react-icons/lu";
import { RiListSettingsLine } from "react-icons/ri";
import { RiFileSettingsLine } from "react-icons/ri";
import { RiVipCrown2Line } from "react-icons/ri";
import { TbShoppingBagCheck } from "react-icons/tb";
import actions from "../../ReduxStore/actions";
import { FaUserCheck } from "react-icons/fa6";
import { FiUser } from "react-icons/fi";
import { HiUserGroup } from "react-icons/hi2";



const EmployeeSidebar = ({ open, onClose }) => {
  const dispatch = useDispatch();

  // const { getPermissionsForAuthUser } = useSelector((state) => state?.getPermissionsForAuthUser);

  // const roleId = sessionStorage.getItem("userRoleId")
  // useEffect(() => {
  //   if (roleId) {
  //     console.log("itssssssssssss")
  //     const data1 = {
  //       data: {},
  //       method: "get",
  //       apiName: `getPermissionsForAuthUser/${roleId}`,
  //     };

  //     dispatch(actions.GETPERMISSIONSFORAUTHUSER(data1));
  //   }
  // }, [])
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedMenu, setExpandedMenu] = useState(null);

  const toggleMenu = (menuName) => {
    setExpandedMenu((prevState) => (prevState === menuName ? null : menuName));
  };

  // const { role, permissions } = useSelector((state) => state.auth); /// Get role and permissions from Redux state
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/employeelogin"); // Redirect to login after logout
    localStorage.setItem("authToken",null)
  };
  // const { permissions } = useSelector((state) => state.auth);
  // const permissions = JSON.parse(localStorage.getItem("permissions")) || {};
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const role = sessionStorage.getItem("role");

  console.log(role, "roleeeeee")

  const SidebarLink = ({ to, icon, label, end = false }) => (
    <NavLink
      to={to}
      end={end}
      style={({ isActive }) => ({
        display: "flex",
        alignItems: "center",
        padding: "10px",
        marginBottom: "10px",
        textDecoration: "none",
        color: isActive ? "black" : "white",
        backgroundColor: isActive ? "white" : "transparent",
        borderRadius: "4px",
      })}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {icon}
        <Typography variant="subtitle1">{label}</Typography>
      </Box>
    </NavLink>
  );

  const SidebarSubmenu = ({ menuName, items, icon, label }) => (
    <Box>
      <Box
        onClick={() => toggleMenu(menuName)}
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          marginBottom: "10px",

          cursor: "pointer",
          color: expandedMenu === menuName ? "white" : "white",
          // color: "white",
          "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
        }}
      >
        {icon}
        {/* {label} */}
        <Typography variant="subtitle1">{label}</Typography>

        <IconButton size="small" sx={{ marginLeft: "auto", color: "white" }}>
          {expandedMenu === menuName ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      {expandedMenu === menuName && (
        <Box sx={{ paddingLeft: 3 }}>
          {items.map(
            (item) =>
              // item.permission && (
              <SidebarLink
                key={item.to}
                to={item.to}
                icon={
                  <GoDotFill
                    // style={{ 
                    style={({ isActive }) => ({

                      color: isActive ? "white" : "red", fontSize: "20px"
                    })} />
                }
                label={item.label}
              />
            // )
          )}
        </Box>
      )}
    </Box>
  );

  const renderSidebarContent = () => (
    <>

      <SidebarLink
        to="/employee"
        icon={<MdOutlineDashboard className="sidebar-icon" />}
        label="Dashboard"
        end
      />
      <SidebarLink
        to="/employee/myappraisal"
        icon={<FiUser className="sidebar-icon" />}
        label="My Appraisal"
        end
      />
      <SidebarLink
        to="/employee/teamappraisal"
        icon={<PiMicrosoftTeamsLogoBold  className="sidebar-icon" />}
        label="Team Appraisal"
        end
      />
      <SidebarLink
        to="/employee/departmentappraisal"
        icon={<HiUserGroup className="sidebar-icon" />}
        label="Department Appraisal"
        end
      />

    </>
  );

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      variant={isMobile ? "temporary" : "permanent"}
      sx={{
        width: 260,

        "& .MuiDrawer-paper": {
          position: { xs: "fixed", md: "static" }, // Fixed for small screens, static for larger screens

          width: 260,
          boxSizing: "border-box",
          background: "#2a3042",
          borderRadius: "10px",
        },
      }}
    >
      <NavLink to="/admin" style={{ textDecoration: "none" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{ height: "47px", width: "180px" }}
          />
        </Box>
      </NavLink>

      <Box
        sx={{ display: "flex", flexDirection: "column", flexGrow: 1, px: 1 }}
      >
        {renderSidebarContent()}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
          color: "white",
          cursor: "pointer",
          fontSize: "16px",
          "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
        }}
        onClick={handleLogout}
      >
        <RxExit style={{ marginRight: "10px" }} />
        Logout
      </Box>
    </Drawer>
  );
};

export default EmployeeSidebar;

